import { Link } from "react-router-dom";
import useSeo from "@/lib/useSeo";

export default function PaymentCancel() {
  useSeo("Payment cancelled");
  return (
    <div data-testid="payment-cancel-page" className="px-6 sm:px-16 py-32">
      <p className="eyebrow text-[var(--mm-red)] mb-4">Payment cancelled</p>
      <p className="font-serif-mm text-5xl">No charge was made. <em>Your bag is saved.</em></p>
      <div className="flex gap-3 mt-10">
        <Link to="/checkout" data-testid="retry-checkout-button" className="btn-mm">Return to checkout</Link>
        <Link to="/shop" className="btn-outline-mm">Keep browsing</Link>
      </div>
    </div>
  );
}
